import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { Suspense, useEffect } from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import './App.css';
import Layout from './components/layout/Layout';
import store from './store';
import { msalConfig } from './config/authConfig';
import PrivateRoute from './routeGuard/PrivateRoute';
import PublicRoute from './routeGuard/PublicRoute';
import ROUTE_SOURCES from './constants/routeSource';
import { Spinner } from './components/loader/view/Loader';
import { ToastContainer } from 'react-toastify';
import { applyHierarchyAliasGlobalPatches } from './utils/hierarchyAliasGlobalPatches';

const msalInstance = new PublicClientApplication(msalConfig);

function App() {
  // Commented to not replace words based on hierarchy
  // useEffect(() => {
  //   applyHierarchyAliasGlobalPatches();
  // }, []);

  const renderRoutes = () => {
    return (
      <Suspense fallback={<Spinner />}>
        <Routes>
          {ROUTE_SOURCES.map(({ path, component: Component, isPublic, allowAuthenticated = false, isLoginPage = false, isShowSidebar = true, roles }, index) => (
            <Route
              key={path}
              path={path}
              element={
                isPublic ? (
                  <PublicRoute allowAuthenticated={allowAuthenticated}>
                    <Layout isShowSidebar={false} isLoginPage={isLoginPage} isPublic={isPublic} roles={roles}><Component /><ToastContainer /></Layout>
                  </PublicRoute>
                ) : (
                  <PrivateRoute>
                    <Layout isShowSidebar={isShowSidebar} roles={roles}><Component /><ToastContainer /></Layout>
                  </PrivateRoute>
                )
              }
            />
          ))}
        </Routes>
      </Suspense>
    )
  };

  return (
    <MsalProvider instance={msalInstance}>
      <Provider store={store}>
        <BrowserRouter>
          {renderRoutes()}
        </BrowserRouter>
      </Provider>
    </MsalProvider>
  );
}

export default App;